module.exports = __webpack_public_path__ + "static/images/dumbbell-blue.f607ee7972d370ddea73022d208d3232.svg";